module.exports = __webpack_public_path__ + "img/income.dd175754.svg";